import { render, staticRenderFns } from "./prnexpert.vue?vue&type=template&id=4c1b9125"
import script from "./prnexpert.vue?vue&type=script&lang=js"
export * from "./prnexpert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports